(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-utils/assets/react/components/pin-icon.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-utils/assets/react/components/pin-icon.js');

'use strict';

const _svs$tur$lyckoplatsen = svs.tur.lyckoplatsen.map,
  pinPath = _svs$tur$lyckoplatsen.pinPath,
  getColor = _svs$tur$lyckoplatsen.getColor;
const PinIcon = _ref => {
  let className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    _ref$useSmallIcon = _ref.useSmallIcon,
    useSmallIcon = _ref$useSmallIcon === void 0 ? false : _ref$useSmallIcon;
  const finalColor = getColor(color);
  return React.createElement("span", {
    className: className
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: useSmallIcon ? 30 : 54,
    height: useSmallIcon ? 44 : 80,
    viewBox: "0 0 54 80",
    fill: "none"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: pinPath,
    fill: finalColor
  })));
};
setGlobal('svs.lyckoplatsen.shared_utils.react.components', {
  PinIcon
});

 })(window);